if (!customElements.get('cart-upsell-recommendations')) {
  customElements.define(
    'cart-upsell-recommendations',
    class CartUpsellRecommendations extends HTMLElement {
      connectedCallback() {
        this.loadRecommendations();
      }

      loadRecommendations() {
        this.loadIndex = (this.loadIndex || 0) + 1;
        const currentLoadIndex = this.loadIndex;
        const urls = (this.dataset.urls || '').split('|').map((url) => url.trim()).filter(Boolean);
        const cartProductIds = new Set(
          (this.dataset.cartProductIds || '').split(',').map((id) => id.trim()).filter(Boolean)
        );
        const limit = parseInt(this.dataset.limit, 10) || 3;
        const list = this.querySelector('.cart-upsell__list');
        const container = this.querySelector('.cart-upsell');

        if (!urls.length || !list || !container) return;

        Promise.all(
          urls.map((url) =>
            fetch(`${url}&source=recommendation_response`)
              .then((response) => response.text())
              .catch((error) => {
                console.error(error);
              return '';
            })
          )
        ).then((responses) => {
          if (currentLoadIndex !== this.loadIndex) return;

          const seenProductIds = new Set();
          const items = [];

          responses.forEach((responseText) => {
            if (items.length >= limit || !responseText) return;

            const html = new DOMParser().parseFromString(responseText, 'text/html');
            html.querySelectorAll('.cart-upsell__item[data-product-id]').forEach((item) => {
              if (items.length >= limit) return;

              const productId = item.dataset.productId;
              if (!productId || cartProductIds.has(productId) || seenProductIds.has(productId)) return;

              seenProductIds.add(productId);
              items.push(item);
            });
          });

          if (!items.length) return;

          list.replaceChildren(...items);
          container.hidden = false;
        });
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.cart-upsell__scroll-button');
  if (!button) return;

  const viewport = button.closest('.cart-upsell__viewport');
  const list = viewport?.querySelector('.cart-upsell__list');
  const item = list?.querySelector('.cart-upsell__item');
  if (!list || !item) return;

  const direction = button.classList.contains('cart-upsell__scroll-button--prev') ? -1 : 1;
  const gap = parseFloat(getComputedStyle(list).columnGap || getComputedStyle(list).gap) || 0;
  const scrollAmount = (item.getBoundingClientRect().width + gap) * 2;

  list.scrollBy({
    left: direction * scrollAmount,
    behavior: 'smooth',
  });
});
